const fr = {
  eyebrow: "FAQ",
  title: "Questions fréquentes",

  items: [
    {
      q: "Quels cours proposez-vous ?",
      a: "Nous proposons des cours en direct et interactifs en programmation et en génie logiciel : IA et apprentissage automatique, conception d'algorithmes, bases de la programmation, architecture logicielle, développement web, développement mobile, et développement de bases de données et de serveurs, du débutant à l'avancé.",
    },
    {
      q: "Faut-il une expérience préalable pour participer ?",
      a: "Aucune expérience préalable n'est requise. Nos cours conviennent à tous les niveaux, du grand débutant au programmeur expérimenté. Vous pouvez partir de zéro, et nous vous guidons pas à pas.",
    },
    {
      q: "Comment se déroulent les cours ?",
      a: "Tous les cours ont lieu en direct en ligne, animés par des instructeurs experts. Les séances sont interactives, avec des projets pratiques et des retours en temps réel. Vous avez manqué une séance ? Nous fournissons des enregistrements à revoir plus tard.",
    },
    {
      q: "Quels langages de programmation enseignez-vous ?",
      a: "Selon le cours : Python, JavaScript, HTML et CSS, React, Swift, Kotlin et SQL. Vous apprendrez les bons outils et langages pour le domaine que vous visez.",
    },
    {
      q: "Comment m'inscrire à un cours ?",
      a: "Parcourez les cours disponibles, choisissez celui qui correspond à votre niveau et inscrivez-vous. Vous recevrez tout le nécessaire pour démarrer. Besoin d'aide pour choisir ? Notre équipe est là pour vous accompagner.",
    },
    {
      q: "Fournissez-vous des certificats de cours ?",
      a: "Oui. À la fin, vous recevez un certificat attestant de vos nouvelles compétences, un atout pour votre CV ou votre portfolio.",
    },
    {
      q: "Combien de temps durent les cours ?",
      a: "La durée varie selon le sujet. Certains sont intensifs et se terminent en quelques semaines, d'autres s'étalent sur plusieurs mois. Chaque page de cours précise le temps à y consacrer.",
    },
    {
      q: "Que faire si j'ai des questions pendant le cours ?",
      a: "Les cours en direct sont interactifs, vous pouvez donc poser vos questions à tout moment. Un accompagnement existe aussi en dehors des séances, via le forum de la communauté et des séances individuelles.",
    },
  ],
};

export default fr;
